<template lang="pug">
  app-modal.modalAvocar(
    titulo="Avocar processo(s)",
    @closeModal="closeModal"
  )
    template(slot="body")
      p.titulo Motivo da avocação do(s) processo(s) selecionado(s).
        span.required &nbsp *
      div.mt-20
      validation-observer(ref='validation' tag='form')
        validation-provider(rules="required", v-slot="{ errors }")
          app-editor-texto.input(
            @onTextChange='emitTextChange'
            :class="{'erro' : errors.length}"
            v-model="texto"
          )
          span.help.erro {{ errors[0] }}
    template(slot="footer")
      .flex
        el-button.btn(
            :id="'cancelarAvocar'",
            type="default",
            size="small",
            @click="closeModal()"
          )
            span.center
              b &nbsp Cancelar
        el-button.btn(
          :id="'confirmarAvocar'",
          type="success",
          size="small",
          @click="avocar"
        )
          span.center
            b &nbsp Confirmar

</template>
<script>
import AppModal from '@/components/AppModal'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'

export default {
  components: {
    AppModal,
    AppEditorTexto
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      texto: ''
    }
  },

  props: {
    idsProcessos: {
      required: true
    }
  },

  methods: {
    ...mapActions({
      avocarProcesso: 'processo/avocarProcesso'
    }),
    closeModal () {
      this.$emit('closeModal')
    },

    async checkValidacao () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_WARNING, 'Por favor, preencha o motivo da avocação.')
        return false
      }
      return true
    },

    emitTextChange (value) {
      this.texto = value
    },

    async avocar () {
      if (!await this.checkValidacao()) {
        return
      }
      const avocar = {
        idProcessos: this.idsProcessos,
        motivo: this.texto
      }

      const response = await this.avocarProcesso(avocar)

      if (!response) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Este processo possui uma conversa em aberto ou pendente e não pode ser avocado.')
      } else {
        this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo avocado com sucesso')
        this.$router.push({
          name: 'CAIXA_ENTRADA'
        })
      }
      this.closeModal()
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.flex {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}

.titulo {
  font-weight: bold;
}

.mt-20 {
  margin-top: 35px;
}

.required {
  color: #b22222;
}

@media (max-width: 780px) {
  .modalAvocar {
    position: fixed !important;
    width: 395px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalAvocar.vue